import { createContext, useContext } from 'react';
import { NotificationActions } from '@frontend/types';

export const NotificationsActions = createContext<NotificationActions | undefined>(undefined);

export const useNotificationsActions = () => {
  const context = useContext(NotificationsActions);

  return context;
};
